import BaseService from './baseService'

import { PortalApiResponse } from '@/types/apiResponses'
import { Portal } from '@/types/portal'

import InvalidPortalError from '@/errors/InvalidPortalError'

class PortalService extends BaseService {
  getPortalData = async (portalDomain: string): Promise<Portal> => {
    const portalData: PortalApiResponse = await this.apiClient.get(
      'portals',
      { domain: portalDomain },
      { headers: { 'X-Bypass-Login': true } }
    )
    if (portalData.data.length === 0) {
      throw new InvalidPortalError('No portal found')
    }
    return portalData.data[0]
  }
}

export default PortalService
